import { IconProps } from "./icon.type";

export function IcOxuLogo(props: IconProps) {
  return (
    <svg
      width="65"
      height="23"
      viewBox="0 0 64.5374 22.6904"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.65598 8.66652L11.3315 9.45737L14.0069 8.66652L13.216 11.3417L14.0069 14.0168L11.3315 13.226L8.65598 14.0168L9.44692 11.3417L8.65598 8.66652Z"
        fill="url(#paint0_linear_oxu_logo)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.344 0C13.3354 0 15.2967 0.526228 17.0159 1.52051L17.0892 1.56152C17.992 2.14385 18.2691 3.3035 17.7376 4.21387C17.3892 4.81892 16.7335 5.19809 16.0267 5.19824C15.6808 5.19824 15.3394 5.10686 15.0394 4.93652L14.889 4.85254C13.8133 4.26015 12.5854 3.94731 11.347 3.94727C9.20055 3.94727 7.16315 4.87497 5.7542 6.49219L5.74932 6.50488C4.45484 7.99755 3.82177 9.90486 3.96416 11.873C4.10658 13.8438 5.00644 15.6393 6.49932 16.9336C7.84206 18.0982 9.56117 18.7392 11.3362 18.7393C13.4853 18.7393 15.5255 17.8085 16.9319 16.1836C18.5493 14.3146 19.1288 11.7742 18.4778 9.3916C17.8446 7.07501 18.2233 5.11879 19.7776 3.7832L19.9095 3.91406C23.587 8.1429 23.5896 14.5303 19.9173 18.7744C17.7633 21.2613 14.6379 22.6878 11.3421 22.6904L11.3392 22.6855C8.6154 22.6855 5.97788 21.7017 3.91533 19.9141C1.624 17.9307 0.243329 15.1741 0.0295926 12.1533C-0.186582 9.13234 0.787087 6.20718 2.7708 3.91602C4.92489 1.42662 8.05067 3.38359e-05 11.344 0ZM64.5218 0.929688L64.5374 12.1318C64.5374 13.328 64.3531 14.4626 64.011 15.5947C62.8417 19.4592 59.703 21.9287 55.678 22.2734C51.3502 22.6427 47.3296 20.6415 45.6185 16.5605C44.9562 14.9778 44.6903 13.3008 44.6878 11.5703L44.6526 0.944336C45.241 0.922183 45.7875 0.897961 46.3733 0.957031C47.8553 1.10964 49.0221 2.28107 49.0296 3.80469L49.095 12.2061C49.1 13.476 49.4272 14.6724 50.0599 15.7529C51.057 17.4586 52.9011 18.3595 54.8606 18.2881C56.6921 18.219 58.3195 17.2986 59.2278 15.6914C59.8285 14.6306 60.1335 13.449 60.136 12.2061L60.1185 3.98242C60.1209 2.3381 61.3145 1.04038 62.9886 0.939453C63.5128 0.907469 64.0025 0.922301 64.5218 0.929688ZM42.3724 0.954102L38.4065 6.65723L35.1321 11.3936V11.3955L36.1341 12.7871L42.8841 22.0986L40.3314 22.1436C38.8322 22.1952 37.466 21.4957 36.6019 20.2725L32.5022 14.4727L28.3177 20.3857C27.584 21.422 26.4438 22.0648 25.1956 22.1436L22.222 22.1064L29.8558 11.5088C29.9197 11.4202 29.8854 11.2586 29.8265 11.1699L22.7044 0.96582C23.7088 0.936282 24.635 0.921553 25.5853 0.960938C26.6658 1.00539 27.5761 1.63143 28.2776 2.40918L29.2532 3.74023L32.5325 8.28711L36.636 2.5957C37.2712 1.71449 38.2711 1.06225 39.3567 0.973633C40.3709 0.892431 41.3262 0.946718 42.3724 0.954102Z"
        fill="url(#paint1_linear_oxu_logo)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_oxu_logo"
          x1="13.4576"
          y1="8.34103"
          x2="9.20093"
          y2="14.3555"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#11E0B0" />
          <stop offset="0.34" stopColor="#11C9FF" />
          <stop offset="1" stopColor="#0163EB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_oxu_logo"
          x1="33.1314"
          y1="-6.44683"
          x2="34.0241"
          y2="33.0921"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#09C3F8" />
          <stop offset="1" stopColor="#0163EB" />
        </linearGradient>
      </defs>
    </svg>
  );
}
